
import { Identity, GenerationConfig, CountryCode } from "../types";

const DATA: Record<string, any> = {
  [CountryCode.US]: {
    firstNames: ['James', 'Mary', 'Robert', 'Patricia', 'John', 'Jennifer', 'Michael', 'Linda', 'William', 'Elizabeth', 'David', 'Barbara', 'Richard', 'Susan', 'Joseph', 'Jessica'],
    lastNames: ['Smith', 'Johnson', 'Williams', 'Brown', 'Jones', 'Garcia', 'Miller', 'Davis', 'Rodriguez', 'Martinez', 'Hernandez', 'Lopez', 'Gonzales', 'Wilson', 'Anderson', 'Thomas'],
    cities: ['New York', 'Los Angeles', 'Chicago', 'Houston', 'Phoenix', 'Philadelphia', 'San Antonio', 'San Diego', 'Dallas', 'San Jose'],
    streets: ['Main St', 'Highland Ave', 'Maple Dr', 'Parkway Dr', 'Oak St', 'Cedar Ln', 'Washington Blvd', 'Lakeview Dr'],
    states: ['NY', 'CA', 'IL', 'TX', 'AZ', 'PA', 'FL', 'WA', 'MA', 'GA'],
    phonePrefix: '+1',
    phoneFormat: '000-000-0000',
    idLabel: 'SSN',
    idFormat: '000-00-0000',
    nameOrder: 'first-last'
  },
  [CountryCode.CN]: {
    firstNames: ['伟', '芳', '建国', '秀英', '敏', '静', '强', '磊', '军', '洋', '勇', '艳', '杰', '娟', '涛', '明'],
    lastNames: ['张', '王', '李', '赵', '刘', '陈', '杨', '黄', '周', '吴', '徐', '孙', '胡', '朱', '高', '林'],
    cities: ['北京', '上海', '广州', '深圳', '杭州', '成都', '武汉', '西安', '南京', '重庆'],
    streets: ['中山路', '人民大道', '建设街', '幸福里', '北京路', '长安街', '解放路', '复兴门内大街'],
    states: ['北京市', '上海市', '广东省', '浙江省', '江苏省', '四川省', '湖北省', '陕西省'],
    phonePrefix: '+86',
    phoneFormat: '100-0000-0000',
    idLabel: '身份证',
    idFormat: '000000000000000000',
    nameOrder: 'last-first'
  },
  [CountryCode.RU]: {
    firstNames: ['Александр', 'Дмитрий', 'Максим', 'Сергей', 'Андрей', 'Иван', 'Елена', 'Мария', 'Ольга', 'Анна', 'Татьяна'],
    lastNames: ['Иванов', 'Смирнов', 'Кузнецов', 'Попов', 'Васильев', 'Петров', 'Соколов', 'Михайлов', 'Новиков', 'Фёдоров'],
    cities: ['Москва', 'Санкт-Петербург', 'Новосибирск', 'Екатеринбург', 'Казань', 'Нижний Новгород'],
    streets: ['Тверская ул.', 'Невский пр.', 'ул. Ленина', 'Садовая ул.', 'пр. Мира', 'ул. Гагарина'],
    states: ['Московская обл.', 'Ленинградская обл.', 'Татарстан', 'Свердловская обл.'],
    phonePrefix: '+7',
    phoneFormat: '900 000-00-00',
    idLabel: 'СНИЛС',
    idFormat: '000-000-000 00',
    nameOrder: 'first-last'
  },
  [CountryCode.JP]: {
    firstNames: ['健', '和也', '翔', '拓海', '翼', '结衣', '爱', '凛', '阳葵', '美月', '大辅', '直树', '裕太', '真央'],
    lastNames: ['佐藤', '铃木', '高桥', '田中', '伊藤', '渡边', '山本', '中村', '小林', '加藤', '吉田', '山田'],
    cities: ['东京', '大阪', '京都', '横滨', '名古屋', '札幌', '福冈', '神户'],
    streets: ['中央通', '明治通', '昭和通', '山手线沿线', '千代田区', '新宿区', '涩谷路'],
    states: ['东京都', '大阪府', '京都府', '神奈川县', '爱知县', '北海道', '兵库县'],
    phonePrefix: '+81',
    phoneFormat: '00-0000-0000',
    idLabel: 'My Number',
    idFormat: '000000000000',
    nameOrder: 'last-first'
  },
  [CountryCode.UK]: {
    firstNames: ['Oliver', 'George', 'Harry', 'Jack', 'Amelia', 'Olivia', 'Isla', 'Ava', 'Thomas', 'Charlie', 'Oscar'],
    lastNames: ['Smith', 'Jones', 'Taylor', 'Williams', 'Brown', 'Davies', 'Evans', 'Wilson', 'Thomas', 'Roberts'],
    cities: ['London', 'Manchester', 'Birmingham', 'Liverpool', 'Glasgow', 'Leeds', 'Bristol', 'Sheffield'],
    streets: ['High Street', 'Station Road', 'London Road', 'Church Street', 'Park Avenue', 'Victoria Road'],
    states: ['England', 'Scotland', 'Wales', 'Northern Ireland'],
    phonePrefix: '+44',
    phoneFormat: '0000 000000',
    idLabel: 'NI Number',
    idFormat: 'AA 00 00 00 A',
    nameOrder: 'first-last'
  },
  [CountryCode.KR]: {
    firstNames: ['민준', '서준', '도윤', '예준', '서연', '서윤', '지우', '하윤', '준호', '상욱', '영희', '철수'],
    lastNames: ['김', '이', '박', '최', '정', '강', '조', '윤', '장', '임', '한', '오'],
    cities: ['서울', '부산', '인천', '대구', '대전', '광주', '울산', '수원'],
    streets: ['세종대로', '종로', '을지로', '강남대로', '테헤란로', '해운대해변로'],
    states: ['서울특별시', '경기도', '경상북도', '전라남도', '충청남도', '제주특별자치도'],
    phonePrefix: '+82',
    phoneFormat: '010-0000-0000',
    idLabel: 'RRN',
    idFormat: '000000-0000000',
    nameOrder: 'last-first'
  },
  [CountryCode.DE]: {
    firstNames: ['Maximilian', 'Alexander', 'Paul', 'Leon', 'Marie', 'Sophie', 'Maria', 'Anna', 'Lukas', 'Jonas'],
    lastNames: ['Müller', 'Schmidt', 'Schneider', 'Fischer', 'Weber', 'Meyer', 'Wagner', 'Becker', 'Schulz'],
    cities: ['Berlin', 'Hamburg', 'München', 'Köln', 'Frankfurt', 'Stuttgart', 'Düsseldorf', 'Dortmund'],
    streets: ['Hauptstraße', 'Schulstraße', 'Gartenstraße', 'Bahnhofstraße', 'Dorfstraße', 'Birkenweg'],
    states: ['Bayern', 'Berlin', 'Hamburg', 'Hessen', 'Sachsen', 'Nordrhein-Westfalen'],
    phonePrefix: '+49',
    phoneFormat: '000 0000000',
    idLabel: 'Steuer ID',
    idFormat: '00 000 000 000',
    nameOrder: 'first-last'
  },
  [CountryCode.FR]: {
    firstNames: ['Lucas', 'Gabriel', 'Louis', 'Arthur', 'Emma', 'Jade', 'Louise', 'Alice', 'Jean', 'Pierre', 'Marie'],
    lastNames: ['Martin', 'Bernard', 'Thomas', 'Petit', 'Robert', 'Richard', 'Durand', 'Dubois', 'Moreau', 'Laurent'],
    cities: ['Paris', 'Marseille', 'Lyon', 'Toulouse', 'Nice', 'Nantes', 'Strasbourg', 'Montpellier'],
    streets: ['Rue de la Paix', 'Boulevard Haussmann', 'Avenue des Champs-Élysées', 'Rue de Rivoli', 'Rue Victor Hugo'],
    states: ['Île-de-France', 'Provence-Alpes-Côte d\'Azur', 'Occitanie', 'Normandie', 'Bretagne'],
    phonePrefix: '+33',
    phoneFormat: '0 00 00 00 00',
    idLabel: 'INSEE',
    idFormat: '0 00 00 00 000 000 00',
    nameOrder: 'first-last'
  }
};

const JOBS = ['Software Engineer', 'Teacher', 'Nurse', 'Marketing Manager', 'Doctor', 'Designer', 'Accountant', 'Lawyer', 'Chef', 'Architect'];
const COMPANIES = ['TechCorp', 'InnovaSoft', 'Global Trade', 'Future Vision', 'Eco Systems', 'Next Gen', 'Apex Solutions'];

const getRandom = (arr: any[]) => arr[Math.floor(Math.random() * arr.length)];

const generateFormattedString = (format: string) => {
  return format.replace(/[0A]/g, (char) => {
    if (char === '0') return Math.floor(Math.random() * 10).toString();
    if (char === 'A') return String.fromCharCode(65 + Math.floor(Math.random() * 26));
    return char;
  });
};

export const generateIdentityLocally = async (config: GenerationConfig): Promise<Identity> => {
  const country = config.country;
  let data = DATA[country as string];
  let isUnsupported = false;

  if (!data) {
    data = DATA[CountryCode.US]; // 回退到美国
    isUnsupported = true;
  }
  
  const firstName = getRandom(data.firstNames);
  const lastName = getRandom(data.lastNames);
  const gender = config.gender === '随机' ? getRandom(['男', '女']) : config.gender;
  const age = Math.floor(Math.random() * (config.maxAge - config.minAge + 1)) + config.minAge;
  const year = new Date().getFullYear() - age;
  
  const name = (data.nameOrder === 'last-first') ? `${lastName}${firstName}` : `${firstName} ${lastName}`;
  const phone = `${data.phonePrefix} ${generateFormattedString(data.phoneFormat)}`;
  const idNumber = generateFormattedString(data.idFormat);
  const job = getRandom(JOBS);
  const company = getRandom(COMPANIES);
  
  return {
    id: Math.random().toString(36).substr(2, 9),
    name: name,
    gender: gender as '男' | '女',
    age: age,
    birthday: `${year}-${String(Math.floor(Math.random() * 12) + 1).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    idNumber: idNumber, 
    address: {
      street: `${Math.floor(Math.random() * 999)} ${getRandom(data.streets)}`,
      city: config.city || getRandom(data.cities),
      state: config.state || getRandom(data.states),
      zipCode: String(Math.floor(Math.random() * 90000) + 10000),
      country: country as string
    },
    phone: phone,
    email: 'TEMP_PLACEHOLDER',
    job: job,
    company: company,
    creditCard: {
      number: `4539 ${Math.floor(Math.random() * 9000 + 1000)} ${Math.floor(Math.random() * 9000 + 1000)} ${Math.floor(Math.random() * 9000 + 1000)}`,
      expiry: '12/28',
      cvv: String(Math.floor(Math.random() * 900) + 100),
      type: 'Visa'
    },
    bio: isUnsupported ? `【本地模式警告】本地算法不支持生成“${country}”的真实身份，已自动回退到美国模板。请登录以使用 AI 深度编织模式。` : '这是一份由本地算法快速生成的身份信息。在设置中绑定 API Key 后可解锁 Gemini 深度编织模式。',
    timestamp: Date.now()
  };
};
